import React, { useMemo } from "react"
import types from "prop-types"
import { isEqual } from "lodash-es"
import { useSelector } from "react-redux"
import { organizationUsersById } from "reduxSlices/organizationUsersSlice"

const UsersAnswerDataElement = ({ value = {} }) => {
  const userIds = value?.user_ids || []
  const users = useSelector(organizationUsersById(userIds), isEqual)

  const userNames = useMemo(() => users.map((user) => user.fullName), [users])

  if (!userIds.length) return (<span />)

  return (
    <span>
      {userNames.join(", ")}
    </span>
  )
}

UsersAnswerDataElement.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  value: types.object,
}

export default UsersAnswerDataElement
